import { clsx } from 'clsx';
import { DayPicker, type DateRange } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

export interface SingleProps {
  mode?: 'single';
  selected?: Date;
  onSelect?: (d: Date | undefined) => void;
  className?: string;
}

export interface RangeProps {
  mode: 'range';
  selected?: DateRange;
  onSelect?: (r: DateRange | undefined) => void;
  className?: string;
}

export type DatePickerProps = SingleProps | RangeProps;

const CLASSNAMES = {
  root: 'p-3 rounded-xl bg-bg-card border border-line text-fg-primary',
  caption: 'flex items-center justify-between mb-2 px-1',
  caption_label: 'text-sm font-semibold',
  nav_button:
    'inline-flex h-7 w-7 items-center justify-center rounded-md text-fg-secondary hover:bg-fill-2 hover:text-fg-primary',
  table: 'w-full border-collapse',
  head_cell: 'text-[10px] uppercase tracking-label text-fg-muted font-bold pb-1',
  cell: 'p-0',
  day: 'h-8 w-8 rounded-md text-xs font-semibold text-fg-secondary hover:bg-fill-2 hover:text-fg-primary',
  day_selected: 'bg-accent text-accent-text hover:bg-accent hover:text-accent-text',
  day_today: 'text-accent',
  day_outside: 'opacity-40',
  day_disabled: 'opacity-30 cursor-not-allowed',
  day_range_middle: 'bg-accent-bg text-accent rounded-none',
  day_range_start: 'rounded-l-md',
  day_range_end: 'rounded-r-md',
};

export function DatePicker(props: DatePickerProps) {
  if (props.mode === 'range') {
    return (
      <DayPicker
        mode="range"
        selected={props.selected}
        onSelect={props.onSelect}
        classNames={CLASSNAMES}
        className={clsx(props.className)}
      />
    );
  }
  return (
    <DayPicker
      mode="single"
      selected={props.selected}
      onSelect={props.onSelect}
      classNames={CLASSNAMES}
      className={clsx(props.className)}
    />
  );
}
